export function getUserInitials(firstName?: string | null, lastName?: string | null): string {
  return [firstName?.[0], lastName?.[0]].filter(Boolean).join('').toUpperCase();
}
